import React, { useState } from 'react';
import AddInfoAuftrag from './AddInfoAuftrag';
import PoliceImage from './PoliceImage';
import HellestelerImage from './HellestelerImage';
import PhotoImage from './PhotoImage';
import UploadSignature from './UploadSignature';

function AddNeuenAuftrag() {
  const [pageState, setPageState] = useState(0);

  const renderPage = () => {
    switch (pageState) {
      case 0:
        return <AddInfoAuftrag pageState={pageState} setPageState={setPageState}/>;
      // case 1:
      //   return <PoliceImage pageState={pageState} setPageState={setPageState}/>;
      // case 2:
      //   return <HellestelerImage pageState={pageState} setPageState={setPageState}/>;
      // case 3:
      //   return <PhotoImage pageState={pageState} setPageState={setPageState}/>;
        // case 4:
        // return <UploadSignature pageState={pageState} setPageState={setPageState} />
      default:
        return <div>Invalid page</div>;
    }
  };

  return (
    <div className="w-full flex flex-col items-center">
      {/* Render the appropriate component */}
      <div className="w-full">{renderPage()}</div>
      
      {/* Navigation buttons */}
      {/* <div className="flex justify-between items-center w-[100%] mt-4">
        <div
          className={`bg-[rgb(255,140,0)] text-[#fff] p-[10px] rounded-[18px] cursor-pointer ${
            pageState === 0 ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          onClick={() => pageState > 0 && setPageState(pageState - 1)}
        >
          Back
        </div>
        <div
          className={`bg-[rgb(255,140,0)] text-[#fff] p-[10px] rounded-[18px] cursor-pointer ${
            pageState === 3 ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          onClick={() => pageState < 3 && setPageState(pageState + 1)}
        >
          Next
        </div>
      </div> */}
    </div>
  );
}

export default AddNeuenAuftrag;
